import Size from '../lib/Cordinates/Size';
import * as PIXI from 'pixi.js';

export default class BaseElement extends PIXI.Sprite {
    constructor(texture, point, size, connections) {
        super(texture);
        this.point = point;
        this.size = size;
        this.connections = connections;
        
        // PIXI props
        this.height = size.scaled.height;
        this.width = size.scaled.width;
    }

    setSize(size) {
        if (!(size instanceof Size)) {
            throw new Error('size must be an instance of Size');
        }

        this.size = size;
        this.height = size.scaled.height;
        this.width = size.scaled.width;
    }

    getConnectorPoints() {
        let ret = [];
        this.connections.forEach(elem => {
            ret.push(this.point.move(elem.cords.x, elem.cords.y));
        });
        return ret;
    }
}
